import { render } from "./CollectionsNFT.vue?vue&type=template&id=64ee176d&scoped=true"
import script from "./CollectionsNFT.vue?vue&type=script&lang=js"
export * from "./CollectionsNFT.vue?vue&type=script&lang=js"

import "./CollectionsNFT.vue?vue&type=style&index=0&id=64ee176d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ee176d"]])

export default __exports__